













import { Component, Vue } from 'vue-property-decorator';
import PhotoPost from "./PhotoPost.vue";
import PostObject from "../../assets/jsons/Posts.json";

@Component({
  components: {
    PhotoPost,
  },
})
export default class Posts extends Vue {
  posts: any[] = [];
  
  getPosts () {
      this.posts = PostObject;
  }

  mounted() {
    this.getPosts()
  }
}
